import Classroom from './Classroom';

export default Classroom;
